import Text from 'components/Text'
import React from 'react'

export default function TextBodyMedium (props) {
  return (
    <Text
      fs='bodyBig'
      {...props}
    />
  )
}
